import useClients from "@/hooks/useClients";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import classes from "./styles.module.scss";

export default function ({ className = "py-5", title = "Featured HRS Clients", EditableText }) {
  const clients = useClients({ featured: true });

  return (
    <div className={cn(className, classes.FeaturedClients)}>
      <ParallaxBackground anim="y0:x0:z0" image={bg_1} className={classes.bg_1} floating={false} />
      <ParallaxBackground anim="y1:x1:z1" image={bg_2} className={classes.bg_2} floating={false} />
      <Container className="mw-lg text-center" fluid="md">
        <EditableText path="title" tag="h2" className="mb-5">
          {title}
        </EditableText>
        <Row>
          {clients.map(({ title, logo, url_slug }) => (
            <Col xs={12} md={6} className="mb-5">
              <a href={`/about-us/featured-clients/${url_slug}/`} className="client">
                <figure>
                  <img src={logo} alt={title} />
                </figure>
                <h3>{title}</h3>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
